<div class="container" [ngClass]="type">
    <h6 *ngIf="localizationCode" appLocalizationPopupDirective [localizationCode]="localizationCode">{{ localizationCode | translate }}</h6>
    <h6 *ngIf="text">{{ text }}</h6>

    <span *ngIf="showClearButton" appPreventDoubleClick (throttledClick)="dismiss()" class="dismiss material-icons-outlined">
        clear
    </span>

    <button 
        *ngIf="button" 
        mat-raised-button 
        setColor="primaryColour" 
        color="primary"
        appPreventDoubleClick (throttledClick)="buttonClick.emit()" 
        class="btn btn-primary" 
        appLocalizationPopupDirective 
        [localizationCode]="button.localizationCode"
    >
        {{ button.localizationCode | translate }}
    </button>
</div>